import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["eventId", "sessionId"],
  _excluded2 = ["mutateAsync"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import api from 'utils/api';
import { eventSessionsQueryKeys } from 'actions/eventSessions';
import { assetQueryKeys } from 'actions/assets';
import { usersQueryKeys } from 'actions/users';
import { setAlert, setSuccessAlert } from 'actions/alerts';
function useAddEventSessionAttendees(_ref) {
  var eventId = _ref.eventId,
    sessionId = _ref.sessionId,
    options = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var queryClient = useQueryClient();
  function addEventSessionAttendees(_x) {
    return _addEventSessionAttendees.apply(this, arguments);
  }
  function _addEventSessionAttendees() {
    _addEventSessionAttendees = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
      var attendeeIds, status;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            attendeeIds = _ref2.attendeeIds, status = _ref2.status;
            return _context2.abrupt("return", api('post', "/api/assets/".concat(eventId, "/sessions/").concat(sessionId, "/attendees"), null, {
              attendeeIds: attendeeIds,
              status: status
            }));
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _addEventSessionAttendees.apply(this, arguments);
  }
  var _useMutation = useMutation(_objectSpread(_objectSpread({
      mutationFn: addEventSessionAttendees
    }, options), {}, {
      onSuccess: function () {
        var _onSuccess = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(data, variables, onMutateResult, context) {
          var _options$onSuccess;
          return _regeneratorRuntime.wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 1;
                return Promise.all([queryClient.invalidateQueries({
                  queryKey: eventSessionsQueryKeys.eventSessions
                }), queryClient.invalidateQueries({
                  queryKey: assetQueryKeys.singleAsset(eventId)
                })]);
              case 1:
                // Clear cache for users query to ensure user picker shows the up to date list
                queryClient.removeQueries({
                  queryKey: usersQueryKeys.usersQuery({
                    assetId: eventId,
                    eventSessionId: sessionId
                  })
                });
                setSuccessAlert({
                  title: t('alert_add_session_attendees_success')
                });
                return _context.abrupt("return", (_options$onSuccess = options.onSuccess) === null || _options$onSuccess === void 0 ? void 0 : _options$onSuccess.call(options, data, variables, onMutateResult, context));
              case 2:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function onSuccess(_x2, _x3, _x4, _x5) {
          return _onSuccess.apply(this, arguments);
        }
        return onSuccess;
      }(),
      onError: function onError(error, variables, onMutateResult, context) {
        var _options$onError;
        setAlert({
          title: t('alert_add_session_attendees_error')
        });
        return (_options$onError = options.onError) === null || _options$onError === void 0 ? void 0 : _options$onError.call(options, error, variables, onMutateResult, context);
      }
    })),
    mutateAsync = _useMutation.mutateAsync,
    result = _objectWithoutProperties(_useMutation, _excluded2);
  return _objectSpread(_objectSpread({}, result), {}, {
    addEventSessionAttendees: mutateAsync
  });
}
export default useAddEventSessionAttendees;